export default __webpack_public_path__ + "static/media/ssnArgentina.7b3953fe.png";